<div class="row mb-2">
  <label class="mb-1 col-sm-12" translate>Label of the drop-down list</label>
  <div class="col-sm-12">
    <input type="text" class="form-control form-control-sm" [(ngModel)]="component.element.label" (ngModelChange)="onLabelChange($event)" />
  </div>
</div>
<div class="mb-2 form-check">    
  <input type="checkbox" class="form-check-input" [(ngModel)]="component.element.show_label" id="show_label" /> 
  <label for="show_label" class="form-check-label" translate>Show label</label> 
</div>
<div class="row mb-2">
  <label class="col-sm-12" translate>Field name</label>
  <div class="col-sm-12">
    <input type="text" name="field_name" [(ngModel)]="component.element.field_name" class="form-control form-control-sm"  maxlength="100">
    <small class="text-muted" translate>max 100 characters</small>
  </div>
</div>


<div class="row">
  <div class="col-md-12">
    <label class="mb-1 d-block" translate>Select Data Source Type</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <mat-select [(ngModel)]="component.element.datasource"
                  #datasourceType="ngModel"
                  required
                  (selectionChange)="onChangeDatasourcetype($event)">
        <mat-option value="" disabled>Select Data Source Type</mat-option>
        <mat-option value="value">Value</mat-option>
        <mat-option value="url">API/URL</mat-option>
      </mat-select>
      <mat-error *ngIf="datasourceType.invalid && datasourceType.touched">
        Data Source Type is mandatory.
      </mat-error>
    </mat-form-field>
  </div>
</div>

<div class="row" *ngIf="component.element.datasource === 'url'">
  <div class="col-md-12">
    <label class="mb-1 d-block" translate>Choose API</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <mat-select [(ngModel)]="component.element.apiEndpoint" (selectionChange)="onChangeAPI($event.value)">
        <mat-select-filter [placeholder]="'Search'" [displayMember]="'APIAliasName'" [array]="apiList"
          (filteredReturn)="filteredAPIS = $event"></mat-select-filter>
        <mat-option *ngFor="let api of filteredAPIS" [value]="api.id">
          {{ api.APIAliasName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="row mb-2" *ngIf="component.element.datasource === 'url'">
  <label class="col-sm-12" translate>Http Request Type(GET,POST,PUT...)</label>
  <div class="col-sm-12">
    <input type="text" name="datasourceurl" placeholder="get,post,put,patch,delete" [(ngModel)]="component.element.requestType" class="form-control form-control-sm">    
  </div>
</div>
<div class="row mb-2" *ngIf="component.element.datasource === 'url'">
  <label class="col-sm-12" translate>Data Source URL</label>
  <div class="col-sm-12">
    <input type="text" name="datasourceurl" [(ngModel)]="component.element.datasourceUrl" class="form-control form-control-sm">    
  </div>
</div>
<div class="row mb-2" *ngIf="component.element.datasource === 'url'">
  <label class="col-sm-12" translate>Data Source Parameters(JSON)</label>
  <div class="col-sm-12">
    <input type="text" name="datasourceparameters" placeholder="{'EG_Id': 0 ,'PT_Id': 0 }" [(ngModel)]="component.element.datasourceParamaters" class="form-control form-control-sm">    
  </div>
</div>

<div class="row mb-2" *ngIf="component.element.datasource === 'url'">
  <label class="col-sm-12" translate>ResultSet(List) Name</label>
  <div class="col-sm-12">
    <input type="text" name="resultsetName" placeholder="groupList" [(ngModel)]="component.element.resultsetName" class="form-control form-control-sm">    
  </div>
</div>

<div class="row mb-2" *ngIf="component.element.datasource === 'url'">
  <label class="col-sm-12" translate>ResultSet Field Name Text,Value(Json)</label>
  <div class="col-sm-12">
    <input type="text" name="resultsetfieldName" placeholder="{'text': 'name' ,'value': 'id' }" [(ngModel)]="component.element.resultsetfieldName" class="form-control form-control-sm">    
  </div>
</div>

<div class="row mb-2" *ngIf="component.element.datasource === 'url'">
  <label class="col-sm-12" translate>Dependent On</label>
  <div class="col-sm-12">
    <input type="text" name="dependenton" placeholder="here write the on depenedent field name" [(ngModel)]="component.element.dependenton" class="form-control form-control-sm">    
  </div>
</div>

<div class="row mb-2" *ngIf="component.element.datasource === 'value'">
  <label class="mb-1 col-sm-12" translate>Options list</label>
  <div class="col-sm-12">
    <table class="table table-sm">
      <tbody>
        <tr *ngFor="let option of component.element.options; let idx = index;">
          <td class="text-center align-middle">
            <div>
              <input
                type="radio"
                name="is_selected"
                [value]="option.id"
                [checked]="option.is_selected"
                (change)="setAsDefault($event)"
              />
            </div>
            <button
              class="btn btn-sm text-danger"
              (click)="removeOption(option.id)"
              [disabled]="component.element.options.length < 3"
            >
              <i class="fas fa-trash"></i>
            </button>
          </td>
          <td>
            <div class="input-group input-group-sm mb-1">              
              <span class="input-group-text option-key-value" translate>Text</span>              
              <input type="text" class="form-control" [placeholder]="'Option ' + idx" [(ngModel)]="option.text" />
            </div>
            <div class="input-group input-group-sm">              
                <span class="input-group-text option-key-value" translate>Value</span>
              <input type="text" class="form-control" [placeholder]="'Value ' + idx" [(ngModel)]="option.value" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <button class="btn btn-link btn-sm" (click)="addOption()">
      <i class="fas fa-plus me-2"></i> <span translate>Add option</span>      
    </button>
  </div>
</div>
<div class="form-check">
  <input type="checkbox" class="form-check-input" [(ngModel)]="component.element.is_required" id="is_required" />
  <label for="is_required" class="form-check-label" translate>Set as required</label>       
</div>